import { render, staticRenderFns } from "./privacyPolicyPage.vue?vue&type=template&id=1821f74a&"
import script from "./privacyPolicyPage.vue?vue&type=script&lang=js&"
export * from "./privacyPolicyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports